// Estilos tipográficos comunes
export const typographyStyles = {
  // Títulos de sección
  sectionTitle: {
    fontFamily: 'Analogue',
    fontSize: '59px',
    lineHeight: '73.75px',
    color: '#50602A',
    '@font-face': {
      fontFamily: 'Analogue',
      src: 'url("/fonts/Analogue.otf") format("opentype")',
      fontWeight: 'normal',
      fontStyle: 'normal'
    }
  },

  // Títulos pequeños
  smallTitle: {
    fontFamily: 'Montserrat',
    fontSize: '19px',
    lineHeight: '22.8px',
    color: '#AF1F2E',
    textTransform: 'uppercase',
    '@font-face': {
      fontFamily: 'Montserrat',
      src: 'url("/fonts/MONTSERRAT-REGULAR.TTF") format("truetype")',
      fontWeight: 'normal',
      fontStyle: 'normal'
    }
  },

  // Texto corrido
  bodyText: {
    fontFamily: 'Montserrat',
    fontSize: '15px',
    lineHeight: '24px',
    color: '#50602A',
    '@font-face': {
      fontFamily: 'Montserrat',
      src: 'url("/fonts/MONTSERRAT-REGULAR.TTF") format("truetype")',
      fontWeight: 'normal',
      fontStyle: 'normal'
    }
  }
};
